import { createAsyncThunk } from "@reduxjs/toolkit";
import { addComment } from "./comments.slice";
import { tooltipAPI } from "libs/apiClient/Tooltip";

export const loadComments = createAsyncThunk("commentsLoadThunk", (url: string) => {
	return tooltipAPI.tooltipList({ url }).then(({ data }) => data);
});

export const createComment = createAsyncThunk(
	"commentsCreateThunk",
	async (data: { key: string; url: string; value: string }, { dispatch }) => {
		await tooltipAPI.tooltipCreate(data).then(({ data }) => dispatch(addComment(data)));
	},
);

export const removeComment = createAsyncThunk("commentsRemoveThunk", async (comment: { key: string; url: string }) => {
	// try {
	await tooltipAPI.tooltipDelete(comment);
	return comment;
	// } catch (e) {
	// 	console.log("error");
	// }
});
export const updateComment = createAsyncThunk(
	"commentsUpdateThunk",
	async (comment: { key: string; url: string; value: string }) => {
		await tooltipAPI.tooltipUpdate(comment);
		return comment;
	},
);
